import { render, staticRenderFns } from "./WarningModal.vue?vue&type=template&id=185f6504&"
import script from "./WarningModal.controller.js?vue&type=script&lang=js&"
export * from "./WarningModal.controller.js?vue&type=script&lang=js&"
import style0 from "./WarningModal.styles.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports